import { createFileRoute } from "@tanstack/react-router";
import { CADIntegrationDetail } from "@/components/views/integrations/CADIntegrationDetail";
import type { IntegrationKey } from "@/data";

const VALID_KEYS: IntegrationKey[] = ["catia", "nx", "freecad"];

export const Route = createFileRoute("/integrations/$cadEnv")({
  component: CadEnvRoute,
});

function CadEnvRoute() {
  const { cadEnv } = Route.useParams();
  const key = (VALID_KEYS as readonly string[]).includes(cadEnv)
    ? (cadEnv as IntegrationKey)
    : "catia";
  return <CADIntegrationDetail envKey={key} />;
}
